import { render, staticRenderFns } from "./junjiashenheNew.vue?vue&type=template&id=4c531d0d&scoped=true"
import script from "./junjiashenheNew.vue?vue&type=script&lang=js"
export * from "./junjiashenheNew.vue?vue&type=script&lang=js"
import style0 from "./junjiashenheNew.vue?vue&type=style&index=0&id=4c531d0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c531d0d",
  null
  
)

export default component.exports